import { AbstractSource } from "../../drawing";

export class DocumentExchangePaperPrintSource extends AbstractSource {
  constructor(getToken: () => string, public readonly patientCode: string, public readonly documentId: number, public readonly edition: number) {
    super(getToken);
  }

  protected getSource(): string {
    const url = "/api/document/" + this.documentId + "/first-registered-pdf-print?token=" + this.token + "&patientCode=" + this.patientCode + "&edition=" + this.edition;
    console.debug("[Source] " + url);
    return url;
  }

  public clone(): DocumentExchangePaperPrintSource {
    return new DocumentExchangePaperPrintSource(
      this._getToken,
      this.patientCode,
      this.documentId,
      this.edition,
    );
  }
}
